import { PatchRequest, PostRequest } from "../../service"


const ControllerName = "Auth"

export const ForgetPassword = (Email) =>
    PatchRequest(ControllerName + "/forget-password", Email)

export const ResendCode = (Email) =>
    PostRequest(ControllerName + "/resend-reset-otp", Email)

export const VerifyResetCode = (CodeData) =>
    PostRequest(ControllerName + "/verify-reset-otp", CodeData)


export const ResetPassword = (ResetPasswordData) =>
    PostRequest(ControllerName + "/reset-password", ResetPasswordData)

export const Login = (userInfo) =>
    PostRequest(ControllerName + "/token", userInfo)


export const Logout = () =>
    PostRequest(ControllerName + "/logout", {})


